import { render, staticRenderFns } from "./OrderStatsDashboard.vue?vue&type=template&id=f0bdc344&scoped=true&"
import script from "./OrderStatsDashboard.vue?vue&type=script&lang=ts&"
export * from "./OrderStatsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStatsDashboard.vue?vue&type=style&index=0&id=f0bdc344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0bdc344",
  null
  
)

export default component.exports